export default __webpack_public_path__ + "static/media/logo_ats4it.e915e697.svg";